import { apiFetch } from '../lib/api';

export const getUserImages = async () => {
  try {
    const response = await apiFetch('/api/gallery/user-images');
    const result = await response.json();
    if (!response.ok) throw new Error(result.error || 'Errore nel recupero immagini');
    return { success: true, images: result.images || [], total: result.total || 0, message: result.message };
  } catch (error) {
    console.error('Errore nel recupero immagini:', error);
    return { success: false, error: error.message || 'Errore interno del server', images: [] };
  }
};

export const toggleImageFavorite = async (imageId, isFavorite) => {
  try {
    const response = await apiFetch('/api/gallery/user-images', {
      method: 'PUT',
      body: JSON.stringify({ imageId, isFavorite }),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.error || 'Errore nell\'aggiornamento preferiti');
    return { success: true, image: result.image };
  } catch (error) {
    console.error('Errore nell\'aggiornamento preferiti:', error);
    return { success: false, error: error.message || 'Errore interno del server' };
  }
};

export const deleteUserImage = async (imageId) => {
  try {
    const response = await apiFetch('/api/gallery/user-images', {
      method: 'DELETE',
      body: JSON.stringify({ imageId }),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.error || 'Errore nell\'eliminazione dell\'immagine');
    return { success: true, imageId: result.imageId };
  } catch (error) {
    console.error('Errore nell\'eliminazione immagine:', error);
    return { success: false, error: error.message || 'Errore interno del server' };
  }
};
